export const VERIFF_HOST_URL = "https://stationapi.veriff.com";
